import React from "react";
import { Box, Container, Grid, Typography, Link, Divider, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

// Substitua pelo caminho da sua logo real
import logoImage from "../assets/images/logo-white.png"; 

// Importação das logos de pagamento

import googleSafeLogo from "../assets/images/google-safe-browsing.svg";

// Função auxiliar para criar o slug da cidade (ex: Belo Horizonte -> belo-horizonte)
const createCitySlug = (city) => {
  return city.normalize("NFD").replace(/[\u0300-\u036f]/g, "") // Remove acentos
    .toLowerCase()
    .replace(/\s+/g, '-'); // Troca espaços por hífens
};

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        background: "linear-gradient(135deg, #8A2BE2 0%, #183cdd 100%)", // Roxo escuro do tema
        color: "#fff",
        pt: 8,
        pb: 4,
        fontSize: "0.9rem",
      }}
    >
      <Container
             maxWidth={false}
             sx={{
               mx: "auto",
               maxWidth:
               {
                 xs: "90%",
                 lg: "90%",
                 "@media (min-width: 2000px)": {
                   maxWidth: "70%"
                 }
               }
             }}
           >
     
        <Grid container spacing={3} justifyContent="space-between">
          
          {/* --- COLUNA 1: LOGO E SOBRE --- */}
          <Grid item xs={12} md={3} sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Box mb={2} sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-start" } }}>
              {/* Logo */}
              <Link component={RouterLink} to="/" underline="none">
                <Box 
                  component="img" 
                  src={logoImage} 
                  alt="DJ Para Festas" 
                  sx={{ maxWidth: "180px", mb: 2, filter: "brightness(0) invert(1)", cursor: "pointer" }} // Filtro para garantir que fique branco se a logo for preta
                />
              </Link>
            </Box>
            <Typography variant="body2" sx={{ lineHeight: 1.8, opacity: 0.8, maxWidth: "300px", mx: { xs: "auto", md: 0 } }}>
              Somos uma plataforma obstinada a estabelecer conexões sólidas entre
              DJs e eventos, proporcionando uma ponte para a colaboração musical.
            </Typography>
          </Grid>

          {/* --- COLUNA 2: INSTITUCIONAL --- */}
          <Grid item xs={6} md={2} sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mb: 2 }}>
              Institucional
            </Typography>
            <Stack spacing={1} alignItems={{ xs: "center", md: "flex-start" }}>
              {[
                { text: "Home", link: "/" },
                { text: "Artistas", link: "/artistas/" },
                { text: "Quem Somos", link: "/quem-somos/" },
                { text: "Política de Privacidade", link: "/politica-privacidade/" },
                { text: "Termos de Uso", link: "/termos-uso/" },
              ].map((item) => (
                <Link
                  key={item.text}
                  component={item.link.startsWith("/") ? RouterLink : "a"}
                  to={item.link.startsWith("/") ? item.link : undefined}
                  href={!item.link.startsWith("/") ? item.link : undefined}
                  underline="none"
                  color="inherit"
                  sx={{ 
                    opacity: 0.8, 
                    "&:hover": { opacity: 1, color: "#00C6FF" },
                    transition: "0.2s"
                  }}
                >
                  {item.text}
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* --- COLUNA 3: SUPORTE --- */}
          <Grid item xs={6} md={2} sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mb: 2 }}>
              Suporte
            </Typography>
            <Stack spacing={1} alignItems={{ xs: "center", md: "flex-start" }}>
              {[
                { text: "Suporte ao Cliente", link: "/suporte/" },
                { text: "Suporte ao Artista", link: "/suporte/" } // Pode direcionar para o mesmo lugar ou outro específico
              ].map((item) => (
                <Link
                  key={item.text}
                  component={RouterLink}
                  to={item.link}
                  underline="none"
                  color="inherit"
                  sx={{ 
                    opacity: 0.8, 
                    "&:hover": { opacity: 1, color: "#00C6FF" },
                    transition: "0.2s"
                  }}
                >
                  {item.text}
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* --- COLUNA 4: PRINCIPAIS LOCAIS --- */}
          <Grid item xs={12} md={2} sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mb: 2 }}>
              Principais Locais
            </Typography>
            <Stack spacing={1} alignItems={{ xs: "center", md: "flex-start" }}>
              {["Belo Horizonte", "Contagem", "Betim", "Nova Lima", "Santa Luzia", "Lagoa Santa", "Sabará", "Ribeirão das Neves", "Vespasiano", "Ibirité", "Caeté", "Brumadinho"].map((city) => (
                <Link
                  key={city}
                  component={RouterLink}
                  to={`/djs/${createCitySlug(city)}/`}
                  underline="none"
                  color="inherit"
                  sx={{ 
                    opacity: 0.8, 
                    "&:hover": { opacity: 1, color: "#00C6FF" },
                    transition: "0.2s"
                  }}
                >
                  {city}
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* --- COLUNA 5: PAGAMENTOS --- */}
          <Grid item xs={12} md={2} sx={{ display: "flex", flexDirection: "column", alignItems: { xs: "center", md: "flex-start" } }}>
            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: { xs: "center", md: "flex-start" } }}>
              
              {/* O Card Branco com as bandeiras */}
              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  p: 2,
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 2,
                  alignItems: "center",
                  justifyContent: { xs: "center", md: "flex-start" },
                  maxWidth: "350px"
                }}
              >
                {[

                  { name: "Google Safe Browsing", src: googleSafeLogo }
                ].map((logo) => (
                  <Box 
                    key={logo.name}
                    component="img"
                    src={logo.src}
                    alt={logo.name}
                    sx={{ height: "auto", width: "auto", objectFit: "contain" }}
                  />
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* --- RODAPÉ INFERIOR (COPYRIGHT) --- */}
        <Divider sx={{ my: 4, borderColor: "rgba(255,255,255,0.1)" }} />

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            opacity: 0.7,
            fontSize: "0.85rem",
            gap: 2
          }}
        >
          <Typography variant="inherit">
            © 2026 Dj Para Festas. Todos os direitos reservados.
          </Typography>
          <Typography variant="inherit">
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;